import axios from "axios"
require('dotenv').config()

const fetchCsrfRequest = () => {
	return {type: "FETCH_CSRF_REQUEST"}
}

const fetchCsrfSuccess = (csrf) => {
	return {type: "FETCH_CSRF_SUCCESS", payload: csrf}
}

const fetchCsrfFailure = (error) => {
	return {type: "FETCH_CSRF_FAILURE", payload: error}
}

export const fetchCsrfCookie = () => {
	return (dispatch) => {
		dispatch(fetchCsrfRequest())
		if (process.env.REACT_APP_MODE === 'development' ) {
			axios.get('http://expo.test/sanctum/csrf-cookie', {withCredentials: true})
			.then(response => {
				const csrf = response.data
				// axios.defaults.headers.post['X-CSRF-TOKEN'] = csrf;
				dispatch(fetchCsrfSuccess(csrf))	
			})
			.catch(err => {
				const error = err.message
				dispatch(fetchCsrfFailure(error))	
			})
		} else {
			axios.get('https://api-expo.irih.ir/sanctum/csrf-cookie', {withCredentials: true})
			.then(response => {
				const csrf = response.data
				// axios.defaults.headers.post['X-CSRF-TOKEN'] = csrf;
				dispatch(fetchCsrfSuccess(csrf))	
			})
			.catch(err => {
				const error = err.message
				dispatch(fetchCsrfFailure(error))	
			})
		}
	}
}